import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'i18n';
import Link from 'components/Link';

import Activity from './Activity';

function ApplicationChangeStage({
  createdAt,
  createdBy,
  inApplicationContext,
  inJobPositionContext,
  stage,
  application,
  t,
  onClick,
  ...rest
}) {
  return (
    <Activity
      icon="user"
      createdAt={createdAt}
      createdBy={createdBy}
      {...rest}
      action={
        inApplicationContext ? (
          <>
            {t('ApplicationChangeStage_changedStageTo')} <b>{stage.name}</b>
          </>
        ) : (
          <Trans
            i18nKey={`ApplicationChangeStage_changedStageTo--extended${
              inJobPositionContext ? 'InJobPosition' : ''
            }`}
          >
            changed stage of{' '}
            <Link
              onClick={onClick}
              to={`/candidates/${application.candidate.pk}/${application.pk}`}
            >
              {{
                candidate: `${application.candidate.firstName} ${application.candidate.lastName}`,
              }}
            </Link>{' '}
            application{' '}
            {!inJobPositionContext ? (
              <>
                for position{' '}
                <b>{{ position: application.jobPosition.position }}</b>
              </>
            ) : (
              ''
            )}{' '}
            to <b>{{ stage: stage.name }}</b>
          </Trans>
        )
      }
    />
  );
}

ApplicationChangeStage.propTypes = {
  createdAt: PropTypes.string,
  createdBy: PropTypes.object,
  inApplicationContext: PropTypes.bool,
  inJobPositionContext: PropTypes.bool,
  stage: PropTypes.object,
  application: PropTypes.object,

  // fired whenever user clicks the activity and is navigated to the link to the activities page,
  // e.g. used to set notification as read
  onClick: PropTypes.func,

  // From HoCs
  t: PropTypes.func.isRequired,
};

export default withTranslation('translation')(ApplicationChangeStage);
